export enum TemplateStatus {
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
  DRAFT = 'draft',
  EDITING = 'editing',
}
